import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApplicantDetailsPreviewResponse } from "../../types";
import { previewResponse } from "../services/apiEndPoints";

export const fetchApplicationPreview = createAsyncThunk<
  ApplicantDetailsPreviewResponse,
  number
>("preview/fetchApplicationPreview", async (access_id) => {
  try {
    const response = await previewResponse({
      access_id,
    });
    return response.data.data;
  } catch (error: any) {
    // return thunkAPI.rejectWithValue(
    //   error.response?.data || error.message || "Failed to load documents"
    // );
  }
});
